import { useOtherSettings } from '@namespace/cms/src/hooks/useOtherSettings';
import { IS_PRERENDER } from '@namespace/helpers';

export const useIsLazyLoadDisabled = (): boolean => {
  const {
    prerender: { isLazyLoadedDisabled }
  } = useOtherSettings();

  return isLazyLoadedDisabled && IS_PRERENDER;
};
